import styled from "styled-components";
import { device } from "../../styles/devices";

export const Filter = styled.section`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2rem;

    @media ${device.tabletLarge}{
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 1rem;
    }
    
    @media ${device.tablet}{
        gap: 0.5rem;
    }

    @media ${device.mobile}{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
    }

    & > div:not(:last-child){
        margin-right: 0.75rem;

        @media ${device.tabletLarge}{
            margin: 0;
        }
    }

    & > div {
        @media ${device.tablet}{
            text-align: center;
        }
        button{
            padding: 1rem 2rem;
            border-radius: var(--button-radius);
            border: none;
            background-color: transparent;
            
            font-weight: var(--font-medium);
            font-size: 1rem;
            text-transform: capitalize;
            color: var(--color-title);

            transition: .3s all;
            box-shadow: 0 1px 8px rgba(0,0,0,0.15);

            @media ${device.tabletLarge}{
                width: 100%;
            }
            @media ${device.tablet}{
                padding: 1rem 1rem;
                font-size: 0.875rem;
            }

            &:hover{
                background-color: var(--color-black-hover);
                color: var(--color-white);
                box-shadow: 0 1px 8px rgba(0,0,0,0.15);
            }

            &.active-button{
                color: var(--color-white);
                background-color: var(--color-black);
                box-shadow: 0 1px 8px rgba(0,0,0,0.15);
            }
        }
    }
`;
export const PortfolioWorksContent = styled.section`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 3rem;
    justify-content: center;
    margin-top: 2rem;

    @media ${device.tabletLarge}{
        gap: 2rem;
    }

    @media ${device.tablet}{
        grid-template-columns: repeat(2, 1fr);
        gap: 1rem;
    }

    @media ${device.mobile}{
        grid-template-columns: repeat(1, 1fr);
        gap: 1rem;
    }

    div{
        padding: 1.25rem;
        border-radius: 1rem;
        background-color: var(--color-white);
        border: 1px solid rgba(0,0,0,0.1);

        text-align: center;
        transition: background-color .3s;

        &:hover{
            background-color: var(--color-white-hover);

            & > a{
                color: #666;  
            }
        }

        img{
            width: 100%;
            border-radius: 1rem;
            margin-bottom: 1rem;
            border: 1px solid rgba(0,0,0,0.1)
        }

        span{
            font-size: 0.812rem;
            font-weight: var(--font-medium);
            color: var(--color-text);
            margin-bottom: 0.5rem;
            display: inline-block;
            opacity: .6;
        }

        h3{
            font-size: 1rem;
            font-weight: var(--font-bold);
            color: var(--color-title);
            line-height: 1.5rem;
            margin-bottom: 0.5rem;
        }

        p{
            font-size: 0.875rem;
            font-weight: var(--font-normal);
            color: var(--color-text);
            margin-bottom: 0.5rem;
        }

        a{
            display: inline-block;

            font-size: 1rem;
            font-weight: var(--font-medium);
            color: var(--color-text);
            line-height: 1.5rem;

            transition: all .3s;

            &:hover{
                color: var(--color-black-hover)!important;
            }
        }
    }
`;